<template>
  <img :src="src" :alt="alt" :title="title" :class="`${className} ${statusClass}`" ref="img" v-on:error="setDefault" />
</template>

<script>

export default {
  props: {
    alt: { type: String, required: false },
    className: { type: String, required: false, default: '' },
    defaultSrc: { type: String, required: false },
    src: { type: String, required: false },
    title: { type: String, required: false }
  },
  data () {
    return {
      statusClass: 'loaded-image'
    }
  },
  mounted () {
    if (!this.src && this.defaultSrc) {
      this.setDefault()
    }
  },
  methods: {
    setDefault () {
      if (this.$refs.img && this.defaultSrc) {
        this.$refs.img.src = this.defaultSrc
        this.statusClass = 'default-image'
      }
    }
  }
}
</script>
